import { render } from "./VueRecaptcha.vue?vue&type=template&id=72277386"
import script from "./VueRecaptcha.vue?vue&type=script&lang=js"
export * from "./VueRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__